import { render } from "./Upload.vue?vue&type=template&id=88617268"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"
script.render = render

export default script